/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Booking_Portal_Nav_Bookings_BadgeInputs */

const en_booking_portal_nav_bookings_badge = /** @type {(inputs: Booking_Portal_Nav_Bookings_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} waiting for your answer`)
};

const pl_booking_portal_nav_bookings_badge = /** @type {(inputs: Booking_Portal_Nav_Bookings_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Czeka na Twoją odpowiedź: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{count} waiting for your answer" |
*
* @param {Booking_Portal_Nav_Bookings_BadgeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_nav_bookings_badge = /** @type {((inputs: Booking_Portal_Nav_Bookings_BadgeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Nav_Bookings_BadgeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_nav_bookings_badge(inputs)
	return en_booking_portal_nav_bookings_badge(inputs)
});